
export class Desposition {
    constructor(public type:string, public desposition:string) {
        
    }
}